var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepeatingBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2123.103,
    height: 1432.828,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1998.103v1340.828H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2123.103v1432.828H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 2",
    transform: "translate(125 92)",
    opacity: 0.103,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 112.488z",
    fill: "#8c8b8b"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 112.555L.126 0l10.741.012-.082 73.162L51.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 112.555L254.126 0l10.741.012-.082 73.162L305.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 112.555L508.126 0l10.741.012-.082 73.162L559.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 112.555L762.126 0l10.741.012-.082 73.162L813.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 112.555L1016.126 0l10.741.012-.082 73.162L1067.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 112.555L1270.126 0l10.741.012-.082 73.162L1321.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 112.555L1524.126 0l10.741.012-.082 73.162L1575.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 112.555L1778.126 0l10.741.012-.082 73.162L1829.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 280.488z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 280.555L.126 168l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 280.555L254.126 168l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 280.555L508.126 168l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 280.555L762.126 168l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 280.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 280.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 280.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 280.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 448.488z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 448.555L.126 336l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 448.555L254.126 336l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 448.555L508.126 336l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 448.555L762.126 336l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 448.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 448.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 448.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 448.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 616.488z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 616.555L.126 504l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 616.555L254.126 504l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 616.555L508.126 504l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 616.555L762.126 504l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 616.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 616.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 616.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 616.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 784.488z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 784.555L.126 672l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 784.555L254.126 672l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 784.555L508.126 672l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 784.555L762.126 672l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 784.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 784.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 784.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 784.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 952.488z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 952.555L.126 840l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 952.555L254.126 840l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 952.555L508.126 840l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 952.555L762.126 840l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 952.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 952.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 952.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 952.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 1120.555L.126 1008l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 1288.555L.126 1176l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 1",
    opacity: 0.103,
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 112.488z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 112.555L.126 0l10.741.012-.082 73.162L51.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 112.555L254.126 0l10.741.012-.082 73.162L305.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 112.555L508.126 0l10.741.012-.082 73.162L559.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 112.555L762.126 0l10.741.012-.082 73.162L813.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 112.555L1016.126 0l10.741.012-.082 73.162L1067.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 112.555L1270.126 0l10.741.012-.082 73.162L1321.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 112.555L1524.126 0l10.741.012-.082 73.162L1575.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 112.555L1778.126 0l10.741.012-.082 73.162L1829.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2122.064 0l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2032 112.555L2032.126 0l10.741.012-.082 73.162L2083.95.058l11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 280.488z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 280.555L.126 168l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 280.555L254.126 168l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 280.555L508.126 168l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 280.555L762.126 168l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 280.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 280.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 280.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 280.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2122.064 168l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2032 280.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 448.488z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 448.555L.126 336l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 448.555L254.126 336l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 448.555L508.126 336l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 448.555L762.126 336l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 448.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 448.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 448.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 448.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2122.064 336l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2032 448.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 616.488z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 616.555L.126 504l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 616.555L254.126 504l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 616.555L508.126 504l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 616.555L762.126 504l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 616.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 616.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 616.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 616.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2122.064 504l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2032 616.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 784.488z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 784.555L.126 672l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 784.555L254.126 672l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 784.555L508.126 672l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 784.555L762.126 672l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 784.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 784.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 784.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 784.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2122.064 672l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2032 784.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116L27 952.488z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 952.555L.126 840l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 952.555L254.126 840l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 952.555L508.126 840l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 952.555L762.126 840l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 952.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 952.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 952.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 952.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2122.064 840l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2032 952.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 1120.555L.126 1008l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2122.064 1008l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2032 1120.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 1288.555L.126 1176l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2122.064 1176l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2032 1288.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M90.064 1344l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M0 1456.555L.126 1344l10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M344.064 1344l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M254 1456.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M598.064 1344l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M508 1456.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M852.064 1344l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M762 1456.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1106.064 1344l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1016 1456.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1360.064 1344l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1270 1456.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1614.064 1344l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1524 1456.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1868.064 1344l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M1778 1456.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2122.064 1344l-.126 112.555-10.741-.012.082-73.162-41.165 73.116-11.114-.009z",
    fill: "#8c8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Words-7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8-7",
    d: "M2032 1456.555l.126-112.555 10.741.012-.082 73.162 41.165-73.116 11.114.009z",
    fill: "#8c8b8b"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatingBackground);
export default __webpack_public_path__ + "static/media/repeatingBackground.0225281752f63f63e9c46505aa67d22d.svg";
export { ForwardRef as ReactComponent };